import React from "react";
import styled from "styled-components";
import { FaTwitch } from "react-icons/fa";
import { RiTiktokLine } from "react-icons/ri";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import { IoCall } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";

const Footer = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:djbezi@topeventsentertainment.co.uk";
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:07886072255";
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <MainWrap>
      <FollowUs>Follow Us!</FollowUs>
      <SocialsWrapper>
        <SocialIcon
          role="link"
          onClick={() => openInNewTab("https://www.instagram.com/bez.niko/")}
        >
          <InstaIcon />
        </SocialIcon>
        <SocialIcon
          role="link"
          onClick={() =>
            openInNewTab("https://www.tiktok.com/@djbezi?_t=8hk6R2GMYmf&_r=1/")
          }
        >
          <TiktokIcon />
        </SocialIcon>
        <SocialIcon
          role="link"
          onClick={() => openInNewTab("https://www.twitch.tv/djbezi_")}
        >
          <TwitchIcon />
        </SocialIcon>
      </SocialsWrapper>
      <ContactWrap>
        <Contact onClick={handleEmailClick}>
          <ContactIcon>
            <EmailIcon />
          </ContactIcon>
          djbezi@topeventsentertainment.co.uk
        </Contact>
        <Contact onClick={handlePhoneClick}>
          <ContactIcon>
            <PhoneIcon />
          </ContactIcon>
          07886072255
        </Contact>
      </ContactWrap>
      <TechWrap>
        <Copyright>
          Copyright © 2023 TOP EVENTS ENTERTAINMENT - All Rights Reserved.
        </Copyright>
        <Power>
          Powered by{" "}
          <a
            role="link"
            onClick={() => openInNewTab("https://gndtdigital.com")}
          >
            GNDTDIGITAL
          </a>
        </Power>
      </TechWrap>
    </MainWrap>
  );
};

export default Footer;

const MainWrap = styled.div`
  width: 100%;
  height: auto;
  background: rgba(0, 0, 0, 0.8);
  color: rgb(192, 192, 192);
`;

const SocialsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FollowUs = styled.div`
  padding: 20px 0 0 0;
`;

const SocialIcon = styled.a`
  width: 30px;
  height: 30px;
  margin: 20px;
  cursor: pointer;

  &:hover {
    color: rgb(142, 234, 83);
  }
`;

const TiktokIcon = styled(RiTiktokLine)`
  height: 100%;
  width: 100%;
`;

const TwitchIcon = styled(FaTwitch)`
  height: 100%;
  width: 100%;
`;

const InstaIcon = styled(FiInstagram)`
  height: 100%;
  width: 100%;
`;

const ContactWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
`;

const Contact = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: rgb(142, 234, 83);
  }
`;

const ContactIcon = styled.a`
  width: 30px;
  height: 30px;
  margin: 10px;
`;

const EmailIcon = styled(MdOutlineEmail)`
  height: 100%;
  width: 100%;
`;

const PhoneIcon = styled(IoCall)`
  height: 90%;
  width: 90%;
`;

const TechWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 40px 40px;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    padding: 50px 20px;
  }
`;

const Copyright = styled.div`
  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

const Power = styled.div`
  cursor: pointer;

  a {
    &:hover {
      color: rgb(142, 234, 83);
    }
  }
`;
